export default "__VITE_ASSET__Wt_hqqj4__"